import styled from "@emotion/styled";
import { palette } from "@jnpmedi/grebob";
import { defaultMarkerColor, getColorBySignerIndex } from "@newComponents/common/Viewer/types";
import { useDocumentMarkerContext } from "@newHooks/context/document/documentMarker.context";
import { EConsentMarkerProps } from "./EConsentMarker";
import { DocumentSignerAttrType } from "@maven-rest/docs/DocumentSign.dto";
import dayjs from "dayjs";

export function CommonMarker(props: EConsentMarkerProps) {
  const { markers } = useDocumentMarkerContext();

  const dateFormat = String(markers.find((e) => e.attr === DocumentSignerAttrType.DateFormat)?.value || "YYYY-MM-DD")
    .split("Z")
    .join(dayjs().format("Z"));

  return (
    <StyledCommonMarker {...props}>
      {props.isModeSigning ? (
        props.marker.attr === DocumentSignerAttrType.Date ? (
          dateFormat
        ) : (
          <>{props.marker.value || props.marker.attr}</>
        )
      ) : (
        props.children
      )}
    </StyledCommonMarker>
  );
}

const StyledCommonMarker = styled("div")<EConsentMarkerProps>((props) => ({
  userSelect: "none",
  boxSizing: "border-box",
  position: "absolute",
  top: props.top,
  left: props.left,
  height: "24px",
  transform: "translateY(-50%)",
  borderRadius: "2px",
  border: props.isModeSigning ? "none" : `2px solid ${palette[getColorBySignerIndex(props.marker.signerIndex).border]}`,

  padding: props.isModeSigning ? "3px" : "1px",
  display: "flex",
  alignItems: "center",

  outline: "none",

  backgroundColor: props.isModeSigning ? defaultMarkerColor.common.background : getColorBySignerIndex(props.marker.signerIndex).background,

  color: props.isModeSigning ? "#000" : "#878d96",
  fontSize: "10px",
  fontWeight: 500,
  lineHeight: "135%",
  whiteSpace: "nowrap",
  textIndent: "0",

  cursor: props.isModeSigning ? "default" : "pointer",

  "&:hover": {
    backgroundColor: props.isModeSigning
      ? defaultMarkerColor.common.backgroundHover
      : getColorBySignerIndex(props.marker.signerIndex).backgroundHover,

    //NOTE: marker hover 시, UnlinkButton이 보임
    "& > span": {
      opacity: 1,
    },
  },
}));
